import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router';
import { useLazyQuery } from '@apollo/client';
import RadioExpansionCard from '../radio-expansion-card/radio-expansion-card';
import Loading from '../loading/loading';
import GET_REFUND_METHODS from '../../gql/refund-methods.gql';
import ErrorDisplay from '../error-display/error-display';

export default function RefundSelection() {
  const {
    refundMethods,
    setRefundMethods,
    selectedRefundMethod,
    setSelectedRefundMethod,
    setReady,
    returnDetails,
    setPageTitle,
    selectedShippingMethod,
  } = useOutletContext();

  const [getRefundMethods, { loading, error, data }] = useLazyQuery(GET_REFUND_METHODS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => setPageTitle('DRE_HOW_WOULD_YOU_LIKE_TO_BE_REFUNDED'), []);

  useEffect(() => setReady(true), []);

  useEffect(() => {
    if (!returnDetails) return;
    getRefundMethods({
      variables: {
        returnDetails: {
          ...returnDetails,
          returnMethodPreference: selectedShippingMethod?.returnMethodPreference,
        },
      },
    });
  }, [returnDetails, selectedShippingMethod]);

  useEffect(() => {
    if (!data) return;
    setRefundMethods(data.refundMethods);
  }, [data]);

  useEffect(() => {
    if (!refundMethods) return;
    if (
      !selectedRefundMethod
      && refundMethods.refundMethods.length < 2
    ) {
      setSelectedRefundMethod(refundMethods.refundMethods[0]);
    }
  }, [refundMethods, selectedRefundMethod]);

  const handleSelectRefundMethod = (refundMethod) => () => {
    setSelectedRefundMethod(refundMethod);
  };

  return (
    <div className="refund-method-card" data-testid="refund-selection">
      {loading && <Loading />}
      {error && <ErrorDisplay apolloError={error} />}
      {!!refundMethods && refundMethods.refundMethods.map((refundMethod, index) => (
        <RadioExpansionCard
          id={`exchange-refund-selection-card-${index}`}
          key={`exchange-refund-selection-card-${refundMethod.id}`}
          highlight={refundMethod.highlightText}
          header={refundMethod.headerText}
          group="refund"
          description={(
            <>
              {refundMethod.displayEstimatedRefund && (
                <h4 data-testid={`estimated-refund-${refundMethod.trackName}`} className="estimated-refund-text">
                  {refundMethod.estimatedRefundText}
                </h4>
              )}
              <p className="refund-method-body-text" data-testid={`refund-method-body-text-${refundMethod.trackName}`}>
                {refundMethod.bodyText}
              </p>
            </>
          )}
          isSelected={selectedRefundMethod?.id === refundMethod.id}
          setSelected={handleSelectRefundMethod(refundMethod)}
          dataTestId={refundMethod.trackName}
        />
      ))}
    </div>
  );
}
